import { useCallback, useState } from 'react';
import { showErrorToast } from '@amigoapp/doca-react';
import { ACCEPTED_FILE_MIME_TYPES, MAX_FILE_SIZE_BYTES } from '../../constants/patientFiles';
import { MAX_PATIENT_DOCUMENT_FILE } from '../../constants/patientFiles';

export const validateFile = (file) => {
	if (!ACCEPTED_FILE_MIME_TYPES.includes(file.type)) {
		return `${file.name}: formato não suportado. Envie JPG, PNG, WEBP ou PDF.`;
	}

	if (file.size > MAX_FILE_SIZE_BYTES) {
		return `${file.name}: arquivo acima de 20 MB.`;
	}

	return null;
};

export function usePatientFileUpload({
	maxFiles,
	currentFiles = [],
	upload,
	onUploaded,
	errorToastMessage,
	onRemove
}) {
	const [loading, setLoading] = useState(false);

	const getValidFiles = useCallback((incoming) => {
		const validFiles = [];

		for (const file of incoming) {
			if (maxFiles && currentFiles.length + validFiles.length >= maxFiles) {
				showErrorToast(`Limite de ${maxFiles} ${maxFiles === MAX_PATIENT_DOCUMENT_FILE ? 'arquivo' : 'arquivos'} atingido.`);
				break;
			}

			const errorMessage = validateFile(file);

			if (errorMessage) {
				showErrorToast(errorMessage);
			} else {
				validFiles.push(file);
			}
		}

		return validFiles;
	}, [maxFiles, currentFiles]);

	const onSelect = useCallback(async (payload) => {
		const incoming = payload?.target?.value;

		if (!incoming?.length) {
			return;
		}

		const validFiles = getValidFiles(incoming);

		if (!validFiles.length) {
			return;
		}

		setLoading(true);
		const result = await upload(validFiles);
		setLoading(false);

		if (result?.skippedRemote) {
			onUploaded(validFiles);
			return;
		}

		if (result?.error) {
			showErrorToast(errorToastMessage);
			return;
		}

		onUploaded(result.data);
	}, [getValidFiles, upload, onUploaded, errorToastMessage]);

	return {
		files: currentFiles,
		loading,
		onSelect,
		onRemove
	};
}
